<script setup>
const props = defineProps({
    color: {
        type: String,
        default: "black",
    },
});
</script>

<template>
    <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.041 9.803L16.5625 10.0437C16.9401 10.4089 16.9401 11.001 16.5625 11.3662L16.318 11.5964L14.3679 11.7051H2.89394C2.57915 11.7051 2.32418 11.6138 2.12901 11.4311C1.94014 11.2424 1.8457 11.0019 1.8457 10.7096C1.8457 10.4113 1.94014 10.1708 2.12901 9.98818C2.32418 9.79945 2.57915 9.70508 2.89394 9.70508H14.3679L16.041 9.803Z"
            :fill="color"
        />
        <path
            d="M13.1543 5.70508L17.4472 9.99797C17.8377 10.3885 17.8377 11.0217 17.4472 11.4122L13.1543 15.7051"
            :stroke="color"
            stroke-width="2"
            stroke-linecap="round"
        />
    </svg>
</template>
